import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { AuthService } from '@cms_root/app/auth/base/services/auth.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiError } from '../../../core/models/api-error.model';

export abstract class ErrorBaseInterceptor implements HttpInterceptor {
  protected abstract statusCode: number;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((httpError: HttpErrorResponse) => {
        if (!AuthService.refreshing && httpError.status === this.statusCode) {
          this.handleError(httpError.error);
        }

        return throwError(httpError);
      })
    );
  }

  protected abstract handleError(error: ApiError): void;
}
